import styled from 'styled-components'

import { Colors } from '@utils/Colors'

export const Container = styled.div`
  & > div {
    width: 100%;
  }
`

export const Header = styled.header`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: 24px;
`

export const List = styled.ol`
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
`

export const Item = styled.li`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 16px;
  width: 100%;
  align-items: flex-start;
  margin-bottom: 16px;
`

export const Number = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: ${Colors.GRAY500};
  color: ${Colors.WHITE};
  font-size: 12px;
  font-weight: 700;
`

export const Buttons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`
